import styled from 'foundations-theming/utils';
import { Table } from 'react-virtualized';
const StyledReactVirtualizedTable = styled(Table).withConfig({
  displayName: "StyledReactVirtualizedTable",
  componentId: "edh4ez-0"
})([".ReactVirtualized__Table__headerColumn,.ReactVirtualized__Table__rowColumn{margin-right:0 !important;margin-left:0 !important;}.ReactVirtualized__Table__headerColumn{border-width:1px 0 1px;}.ReactVirtualized__Table__row{border-width:0 0 1px;}.ReactVirtualized__Table__headerColumn,.ReactVirtualized__Table__row{border-color:", ";border-style:solid;}.objects-table-header{font-size:12px;font-weight:500;background-color:", ";color:", ";height:3.25rem;padding:0.75rem 1.5rem 0.5rem;text-align:left;text-transform:uppercase;vertical-align:middle;}.objects-table-row{hyphens:auto;overflow-wrap:break-word;padding:0 1.5rem;vertical-align:middle;}"], ({
  theme
}) => theme.color['do-not-use-great-white'], ({
  theme
}) => theme.color['do-not-use-gypsum'], ({
  theme
}) => theme.color['do-not-use-obsidian']);
export default StyledReactVirtualizedTable;